import { render, staticRenderFns } from "./ColoredDrawer.vue?vue&type=template&id=00ec6b70&"
import script from "./ColoredDrawer.vue?vue&type=script&lang=js&"
export * from "./ColoredDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports